import axios from './axyos';

export interface AddressSuggestion {
  id: string;
  source: 'quartier' | 'commune' | 'wilaya';
  label: string;
  quartierId?: string;
  communeId?: string;
  wilayaId?: string;
  address?: string;
  coordinates?: GeocodeAddressResult;
}

export interface WilayaOption {
  id: string;
  name: string;
  postCode: string;
  code: string;
}

export interface CommuneOption {
  id: string;
  name: string;
  postCode: string;
  code: number;
  wilayaId: string;
}

export interface ManualAddressPayload {
  address: string;
  wilayaId: string;
  communeId: string;
  coordinates?: GeocodeAddressResult;
}

export interface AddressGeometryValidationResult {
  valid: boolean;
  message: string;
}

export interface QuartierMissingCoordinatesOption {
  id: string;
  name: string;
  nameAr: string;
  label: string;
}

export interface GeocodeAddressResult {
  latitude: number;
  longitude: number;
}

export interface ReverseGeocodeAddressResult {
  address: string;
  coordinates: GeocodeAddressResult;
}

export const searchAddressSuggestionsApi = async (query: string) => {
  return axios.get<{ status: number; data: AddressSuggestion[] }>('/locations/search', {
    params: { q: query },
  });
};

export const geocodeAddressApi = async (address: string) => {
  return axios.post<{ status: number; data: GeocodeAddressResult }>('/locations/geocode', {
    address,
  });
};

export const reverseGeocodeCoordinatesApi = async (coordinates: GeocodeAddressResult) => {
  return axios.post<{ status: number; data: ReverseGeocodeAddressResult }>('/locations/reverse-geocode', coordinates);
};

export const listWilayasApi = async () => {
  return axios.get<{ status: number; data: WilayaOption[] }>('/locations/wilayas');
};

export const listCommunesByWilayaApi = async (wilayaId: string) => {
  return axios.get<{ status: number; data: CommuneOption[] }>('/locations/communes', {
    params: { wilayaId },
  });
};

export const listAllQuartiersApi = async (searchQuery?: string) => {
  return axios.get<{ status: number; data: QuartierMissingCoordinatesOption[] }>('/locations/quartiers', {
    params: searchQuery ? { q: searchQuery } : {},
  });
};

export const listQuartiersMissingCoordinatesApi = async () => {
  return axios.get<{ status: number; data: QuartierMissingCoordinatesOption[] }>(
    '/admin/locations/quartiers/missing-coordinates'
  );
};

export const refreshQuartierCoordinatesApi = async (quartierId: string) => {
  return axios.post<{ status: number; data?: { latitude: number; longitude: number }; message?: string }>(
    `/admin/locations/quartiers/${encodeURIComponent(quartierId)}/refresh-coordinates`
  );
};
